import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import Navbar from './components/feature/Navbar';
import Footer from './components/feature/Footer';
import CookieBanner from './components/feature/CookieBanner';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <div className="min-h-screen bg-white">
        <Navbar />
        <AppRoutes />
        <Footer />
        <CookieBanner />
      </div>
    </BrowserRouter>
  );
}

export default App;
